import React, { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom"; // ✅ use SPA routing
import "./Herosection.scss";
import heroImg from "../../assets/Hero.jpg";
import shape from "../../assets/shape.png";
import shape2 from "../../assets/shape2.png";
import shape3 from "../../assets/shape3.png";

const Hero = () => {
  const [parallax, setParallax] = useState({ x: 0, y: 0 });
  const ticking = useRef(false);
  const rootRef = useRef(null);

  useEffect(() => {
    const prefersReduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

    function onMouseMove(e) {
      if (window.innerWidth < 1400 || prefersReduced) return;

      const vw = window.innerWidth;
      const vh = window.innerHeight;
      const nx = (e.clientX - vw / 2) / (vw / 2);
      const ny = (e.clientY - vh / 2) / (vh / 2);

      if (!ticking.current) {
        window.requestAnimationFrame(() => {
          const clamp = (v, min, max) => Math.max(min, Math.min(max, v));
          setParallax({ x: clamp(nx, -1, 1), y: clamp(ny, -1, 1) });
          ticking.current = false;
        });
        ticking.current = true;
      }
    }

    window.addEventListener("mousemove", onMouseMove, { passive: true });
    return () => window.removeEventListener("mousemove", onMouseMove);
  }, []);

  const d1 = 14, d2 = 10, d3 = 8;

  const t1 = {
    transform: `translate3d(${(-parallax.x * d1).toFixed(2)}px, ${(parallax.y * d1 * 0.8).toFixed(2)}px, 0)`
  };
  const t2 = {
    transform: `translate3d(${(parallax.x * d2 * 0.9).toFixed(2)}px, ${(-parallax.y * d2).toFixed(2)}px, 0)`
  };
  const t3 = {
    transform: `translate3d(${(-parallax.x * d3 * 0.6).toFixed(2)}px, ${(parallax.y * d3 * 0.6).toFixed(2)}px, 0)`
  };

  return (
    <section
      ref={rootRef}
      className="avena-hero"
      style={{
        backgroundImage: `url(${heroImg})`,
        "--hero-content-width": "720px",
      }}
    >
      <div className="avena-hero__overlay">
        <div className="container p-0">
          <div className="row g-0 align-items-stretch avena-hero__row">
            {/* Left text panel */}
            <div className="col-12 col-lg-6 avena-hero__left">
              <div className="container h-100">
                <div className="row h-100">
                  <div className="col-12 col-xl-9 d-flex flex-column justify-content-center avena-hero__content">
                    <h1 className="avena-hero__title">
                      Smart &amp; Simple<br />IT Solutions
                    </h1>

                    <p className="avena-hero__subtitle">
                      We bring clarity to complexity designing secure software and dependable hardware that keep your operations fast, scalable, and effortless.
                    </p>

                    <div className="avena-hero__actions">
                      <Link to="/about" className="btn avena-hero__btn avena-hero__btn--solid">
                        EXPLORE MORE
                      </Link>
                      <Link to="/contact" className="btn avena-hero__btn avena-hero__btn--ghost">
                        SPEAK WITH EXPERT
                      </Link>

                      {/* Decorative shapes (parallax) */}
                      <img className="shape-hero3" src={shape3} alt="" style={t3} />
                      <img className="shape-hero2" src={shape2} alt="" style={t2} />
                      <img className="shape-hero" src={shape} alt="" style={t1} />
                      
                      
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Right half image area (desktop only) */}
            <div className="d-none d-lg-block col-lg-6 avena-hero__right" />
          </div>
        </div>
      </div>

      {/* === FEATURE STRIP (becomes static below hero on mobile) === */}
      <div className="avena-hero__featurebar">
        <div className="container">
          <div className="row g-0 avena-feature">
            {/* Software card */}
            <div className="col-12 col-lg-6">
              <article className="avena-feature__card avena-feature__card--light">
                <div className="avena-feature__icon">
                  <svg width="28" height="28" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                    <rect x="3" y="4" width="18" height="14" rx="2" stroke="currentColor" strokeWidth="2" />
                    <path d="M3 8h18" stroke="currentColor" strokeWidth="2" />
                    <circle cx="7" cy="6" r="1" fill="currentColor" />
                    <circle cx="10" cy="6" r="1" fill="currentColor" />
                    <circle cx="13" cy="6" r="1" fill="currentColor" />
                  </svg>
                </div>
                <div className="avena-feature__body">
                  <h3 className="avena-feature__title">Software Solutions</h3>
                  <p className="avena-feature__text">
                    Secure, scalable applications tailored to your workflow—web, mobile, cloud, and integrations.
                  </p>
                </div>
              </article>
            </div>

            {/* Hardware card */}
            <div className="col-12 col-lg-6">
              <article className="avena-feature__card avena-feature__card--dark">
                <div className="avena-feature__icon avena-feature__icon--ghost">
                  <svg width="28" height="28" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                    <rect x="4" y="4" width="16" height="6" rx="2" stroke="currentColor" strokeWidth="2" />
                    <rect x="4" y="14" width="16" height="6" rx="2" stroke="currentColor" strokeWidth="2" />
                    <circle cx="8" cy="7" r="1" fill="currentColor" />
                    <circle cx="8" cy="17" r="1" fill="currentColor" />
                  </svg>
                </div>
                <div className="avena-feature__body">
                  <h3 className="avena-feature__title">Hardware Solutions</h3>
                  <p className="avena-feature__text">
                    Reliable infrastructure—servers, networks, CCTV &amp; access control—installed and maintained.
                  </p>
                </div>
                <span className="avena-feature__corner" aria-hidden="true" />
              </article>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
